import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { isNullUndefinedOrEmptyString } from "common/utils/valueChecks";
import { TableCellSelect, TableCellTextField } from "common/Components/tableCellForm.styles";

const EMPTY_PLACEHOLDER = "—";

function formatDisplayTitle(rawValue) {
  return rawValue != null ? String(rawValue) : "";
}

function formatDisplayContent(rawValue) {
  if (isNullUndefinedOrEmptyString(rawValue)) {
    return EMPTY_PLACEHOLDER;
  }
  return String(rawValue);
}

export default function TableEditableCell({
  fieldType,
  columnLabel,
  value,
  onChange,
  selectOptions,
}) {
  if (fieldType === "text") {
    return (
      <TableCellTextField
        size="small"
        fullWidth
        variant="outlined"
        value={value ?? ""}
        onChange={(event) => onChange?.(event.target.value)}
        inputProps={{ "aria-label": columnLabel }}
      />
    );
  }

  if (fieldType === "select") {
    const options = selectOptions ?? [];
    return (
      <TableCellSelect
        size="small"
        fullWidth
        displayEmpty
        value={value ?? ""}
        onChange={(event) => onChange?.(event.target.value)}
        inputProps={{ "aria-label": columnLabel }}
      >
        <MenuItem value="">
          <em>{EMPTY_PLACEHOLDER}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TableCellSelect>
    );
  }

  const displayText = formatDisplayContent(value);
  return (
    <Typography
      variant="body2"
      noWrap
      title={formatDisplayTitle(value)}
    >
      {displayText}
    </Typography>
  );
}

TableEditableCell.propTypes = {
  fieldType: PropTypes.oneOf(["text", "select", "display"]).isRequired,
  columnLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

TableEditableCell.defaultProps = {
  value: "",
  onChange: undefined,
  selectOptions: [],
};
